import { getToken, resetState } from "../utils/index";

export default {
  namespaced: true,
  state: {
    error: null,
    loading: false,
    refresh: false,
    initialLoad: true,
    accountsTransactions: {
      data: [],
    },
    accountsOverview: {},
  },
  mutations: {
    GET_ACCOUNTS_TRANSACTIONS_START: (state) => {
      state.loading = true;
    },
    GET_ACCOUNTS_TRANSACTIONS_FAILED: (state, error) => {
      state.loading = false;
      state.refresh = false;
      state.error = error;
    },
    GET_ACCOUNTS_TRANSACTIONS_SUCCESS: (state, accountsTransactions) => {
      state.loading = false;
      state.refresh = false;
      state.initialLoad = false;
      state.accountsTransactions = accountsTransactions;
      console.log(accountsTransactions);
    },
    GET_ACCOUNTS_OVERVIEW_START: (state) => {
      state.loading = true;
    },
    GET_ACCOUNTS_OVERVIEW_FAILED: (state, error) => {
      state.loading = false;
      state.refresh = false;
      state.error = error;
    },
    GET_ACCOUNTS_OVERVIEW_SUCCESS: (state, accountsOverview) => {
      state.loading = false;
      state.refresh = false;
      state.accountsOverview = accountsOverview;
      console.log(accountsOverview);
    },
    REFRESH: (state) => {
      state.refresh = true;
    },
  },
  actions: {
    async getAccountsTransactions({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_ACCOUNTS_TRANSACTIONS_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/transactions?type=account&start=${payload.startDate}&end=${payload.endDate}&show=20`,
          config
        );
        const data = await response.json();
        commit("GET_ACCOUNTS_TRANSACTIONS_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_ACCOUNTS_TRANSACTIONS_FAILED", err);
      }
    },
    async getAccountsOverview({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_ACCOUNTS_OVERVIEW_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/transactions/overview?type=account&start=${payload.startDate}&end=${payload.endDate}`,
          config
        );
        const data = await response.json();
        commit("GET_ACCOUNTS_OVERVIEW_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_ACCOUNTS_OVERVIEW_FAILED", err);
      }
    },
    async refresh({ commit }) {
      commit("REFRESH");
    },
  },
};
